import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { FireIcon, PlusIcon } from '@heroicons/react/24/outline';
import { api } from '../../services/api';

const Workouts: React.FC = () => {
  const { data: workoutsData, isLoading } = useQuery({
    queryKey: ['workouts'],
    queryFn: () => api.get('/workouts'),
  });

  const workouts = workoutsData?.data?.workouts || [];

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Workouts</h1>
          <p className="text-gray-600">Track your fitness progress</p>
        </div>
        <div className="mt-4 sm:mt-0">
          <button className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700">
            <PlusIcon className="h-5 w-5 mr-2" />
            Create Workout
          </button>
        </div>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          {workouts.length > 0 ? (
            <div className="space-y-4">
              {workouts.map((workout: any) => (
                <div
                  key={workout.id}
                  className="flex items-center justify-between p-4 bg-gray-50 rounded-lg"
                >
                  <div className="flex items-center">
                    <FireIcon className="h-8 w-8 text-blue-500 mr-4" />
                    <div>
                      <h3 className="text-lg font-medium text-gray-900">
                        {workout.name}
                      </h3>
                      <p className="text-sm text-gray-500">
                        {workout.description}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    {workout.isCompleted ? (
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        Completed
                      </span>
                    ) : (
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                        Pending
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <FireIcon className="mx-auto h-12 w-12 text-gray-400" />
              <h3 className="mt-2 text-sm font-medium text-gray-900">No workouts</h3>
              <p className="mt-1 text-sm text-gray-500">
                Get started by creating your first workout.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Workouts;
